( function () {
	'use strict';

	function modelChangeEvent ( _, $timeout ) {
		function link ( $scope ) {
			// set initialize to true if first load
			var initialize = true;

			function loopSubOptions ( subOption ) {
				delete subOption.redac;
				delete subOption.tempValue;

				return subOption;
			}

			function loopOptions ( optionObj ) {
				delete optionObj.redac;
				delete optionObj.tempValue;
				optionObj.subOptions = ( optionObj.subOptions || [] ).map( loopSubOptions );

				return optionObj;
			}

			function mapIndicators ( indicator ) {
				delete indicator.redac;
				indicator.questionText  = _.unescape( indicator.questionText );
				indicator.answerOptions = ( indicator.answerOptions || [] ).map( loopOptions );

				return indicator;
			}

			function mapGroups ( group ) {
				return ( group.indicators || [] ).map( mapIndicators );
			}

			function removeUnnecessaryAttr ( model ) {
				( model.groups || [] ).forEach( mapGroups );
				return model;
			}

			function debounce ( callback, interval ) {
				var timeout = null;

				return function ( newValue, oldValue ) {
					var newModel = removeUnnecessaryAttr( angular.copy( newValue ) );
					var oldModel = removeUnnecessaryAttr( angular.copy( oldValue ) );

					// check if newValue is not equal to oldValue and
					// check if not first load
					if ( angular.toJson( newModel ) !== angular.toJson( oldModel ) && !initialize ) {
						$timeout.cancel( timeout );
						var args = [ newModel, oldModel ];

						timeout = $timeout( function () {
							callback.apply( this, args );
						}, interval );
					}

					initialize = false;
				};
			}

			$scope.$watch( 'model', debounce( $scope.onChange, 1000 ), true );
		}

		return {
			'link'     : link,
			'restrict' : 'AE',
			'scope'    : {
				'model'    : '=',
				'onChange' : '&'
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'modelChangeEvent', modelChangeEvent );

	modelChangeEvent.$inject = [ '_', '$timeout' ];
} )( );
